import React from "react";
import Button from "@mui/material/Button";
import "./index.css";
import { Link } from "react-router-dom";
const header = () => {
  return (
    <div className="App-header drop-shadow">
      <Link to={"/"} onClick={() => localStorage.clear()}>
        <div className="App-logo"></div>
      </Link>
      <Button
        id="checkBooking"
        component={Link}
        to={"CheckBooking"}
        variant="contained"
        onClick={() => localStorage.clear()}
        style={{
          fontSize: "0.75rem",
          fontWeight: "bold",
          borderRadius: "8px",
          backgroundColor: "#ffffff",
          color: "#384285",
        }}
      >
        CHECK BOOKING
      </Button>
    </div>
  );
};

export default header;
